<template>
  <div class="login-wrapper d-flex align-items-center justify-content-center">
    <div class="login-container d-flex shadow-lg">
      <!-- Left Side: Logo & Branding -->
      <div
        class="login-brand d-flex flex-column align-items-center justify-content-center"
      >
        <img
          :src="require('@/assets/img/medleyhmslogo.png')"
          alt="Logo"
          class="brand-logo"
        />
      </div>

      <!-- Right Side: Login Form -->
      <div class="login-card p-5">
        <div v-if="loading" class="text-center py-4">
          <div class="spinner-border mb-3"></div>
          <p class="fw-bold">⏳ Authenticating...</p>
        </div>

        <div v-else>
          <div>
            <h2 class="fw-bold text-center text-dark">👋 Welcome Back</h2>
            <p class="text-muted text-center mt-2">
              Sign in to continue to your dashboard
            </p>
          </div>

          <form class="text-start" @submit.prevent="send_verification">
            <label class="fw-semibold">📧 Email</label>
            <!-- <soft-input
              :style="failed_trial ? 'border: 1px solid red' : ''"
              id="email"
              type="email"
              placeholder="Enter your email"
              name="email"
              v-model="email"
            /> -->
            <input
              :style="failed_trial ? 'border: 1px solid red' : ''"
              id="email"
              type="email"
              placeholder="Enter your email"
              name="email"
              v-model="email"
              class="form-control"
            />

            <label class="fw-semibold mt-3">🔒 Password</label>
            <div class="password-wrapper" style="position: relative">
              <!-- Use standard input for password -->
              <input
                :style="failed_trial ? 'border: 1px solid red' : ''"
                id="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Enter your password"
                class="form-control"
                v-model="password"
              />
              <button
                type="button"
                @click="showPassword = !showPassword"
                style="
                  position: absolute;
                  right: 10px;
                  top: 50%;
                  transform: translateY(-50%);
                  background: none;
                  border: none;
                  cursor: pointer;
                  font-size: 1rem;
                "
              >
                {{ showPassword ? "🙈" : "👁️" }}
              </button>
            </div>

            <div class="text-end mt-2">
              <button
                type="button"
                class="btn-link-custom"
                @click="showPassReset"
              >
                ❓ Forgot Password?
              </button>
            </div>

            <soft-button
              class="mt-4"
              variant="gradient"
              color="dark"
              full-width
              type="submit"
            >
              🔑 Sign In
            </soft-button>

            <p class="text-danger text-center mt-3" v-if="error">
              ⚠ {{ error }}
            </p>
          </form>
        </div>
      </div>
    </div>

    <ForgotPassword v-if="showForgot" @close-pass="showForgot = false" />
  </div>
</template>

<script>
// import SoftInput from "@/components/SoftInput.vue";
import SoftButton from "@/components/SoftButton.vue";
import ForgotPassword from "./forgot_password_modal.vue";
import { postMethodRequest } from "../api/apiIndex";
import { mapMutations } from "vuex";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "SignIn",
  components: { SoftButton, ForgotPassword },

  data() {
    return {
      email: "",
      password: "",
      error: "",
      loading: false,
      failed_trial: false,
      showForgot: false,
      showPassword: false,
    };
  },

  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    showPassReset() {
      this.showForgot = true;
    },

    async callApi() {
      console.log({
        email: this.email,
        password: this.password,
      });

      try {
        const data = await postMethodRequest("login", {
          email: this.email,
          password: this.password,
        });

        this.$store.dispatch("updateUser", data.user);
        this.$store.dispatch("updatePermissions", data.permissions);
        this.$store.dispatch("updateToken", data.token);
        this.$store.dispatch("updateTime", data.time);
        this.$store.dispatch("updateCompany", data.company_name);
        this.$store.dispatch("updateLogo", data.logo);
        this.$store.dispatch("updateCompanyActive", data.company_active);
        this.$store.dispatch("updatePackageItems", data.package_items);
      } catch (error) {
        this.error = "Invalid username or password !!";
        this.failed_trial = true;
        this.loading = false;
      }
    },

    async send_verification() {
      this.error = "";
      this.loading = true;
      await this.callApi();
      if (this.$store.getters.isAuthenticated) {
        window.location.replace("/");
      }
    },
  },

  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },

  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },

  mounted() {
    if (this.$store.getters.isAuthenticated) {
      window.location.replace("/dashboard");
    }
  },
};
</script>

<style scoped>
.login-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-container {
  width: 900px;
  min-height: 520px;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
}

.login-brand {
  width: 50%;
  background: #fafbfc;
  border-right: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-logo {
  width: 100%;
  max-width: 960px;
  height: auto;
  object-fit: contain;
}

.login-card {
  width: 50%;
  background: white;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.btn-link-custom {
  background: none;
  border: none;
  color: #0066cc;
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: underline;
}
.btn-link-custom:hover {
  color: #004c99;
}

.password-wrapper input {
  width: 100%;
  padding-right: 40px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ced4da;
}

@media (max-width: 992px) {
  .login-container {
    width: 95%;
    min-height: auto;
  }
  .login-brand {
    padding: 20px;
  }
  .login-card {
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .login-container {
    width: 95%;
    min-height: auto;
    flex-direction: column;
  }
  .login-brand {
    display: none !important;
  }
  .login-card {
    width: 100% !important;
    padding: 25px;
  }
}

@media (max-width: 480px) {
  .login-wrapper {
    padding: 10px;
  }
  .login-card {
    padding: 20px;
  }
  .brand-logo {
    max-width: 200px;
  }
}
</style>
